import classnames from "classnames";
import React from "react";

import { useGranite } from "@redux/modules/value/translations/translations.provider";

import { Input } from "@components/General/Form/input.component";
import { InputGroup } from "@components/General/Form/inputGroup.component";
import { InputGroupText } from "@components/General/Form/inputGroupText.component";
import { Label } from "@components/General/Form/label.component";
import { Col } from "@components/General/Grid/col.component";

import "./calculationField.scss";

type Props = {
    name: string;
    dimension: string;
    unit: string | null;
    sup?: number | undefined;
    setCalculationValue: (name: string, value: string) => void;
    value?: any | undefined;
    sm?: number;
    md?: number;
    lg?: number;
    classNames?: string;
};

const CalculationField = ({
    name,
    dimension,
    unit,
    sup,
    setCalculationValue,
    value,
    sm,
    md,
    lg,
    classNames,
}: Props) => {
    const { t } = useGranite();

    const validateNumber = (e: any) => {
        if (
            e.keyCode === 46 || // left
            e.keyCode === 8 || // right
            e.keyCode === 9 || // tab
            e.keyCode === 39 || // backspace
            e.keyCode === 37 // delete
        ) {
            return true;
        }

        if (
            // input is not number or , or .
            !/[\d,.]/.test(e.key) ||
            // number is not formatted with ',' as decimal point
            !/^\d*[.,]?(\d*)?$/.test(e.target.value + e.key)
        ) {
            return e.preventDefault();
        }

        return true;
    };

    const formatNumber = (e: any) => {
        return e.target.value.replace(",", ".");
    };

    return (
        <Col sm={sm} md={md} lg={lg} className={classnames("mt-3", classNames)}>
            <Label for={name}>{t(`calculator.${dimension}`)}</Label>
            <InputGroup>
                <Input
                    name={name}
                    type="text"
                    inputMode="decimal"
                    maxLength={6}
                    placeholder="0"
                    onKeyDown={e => validateNumber(e)}
                    onChange={e => setCalculationValue(name, formatNumber(e))}
                    value={value}
                />
                {unit && (
                    <InputGroupText
                        className={"calculator-calculation-field-unit"}
                    >
                        {unit}
                        {unit && sup && <sup>{sup}</sup>}
                    </InputGroupText>
                )}
            </InputGroup>
        </Col>
    );
};

export default CalculationField;
